import { connect } from "react-redux";
import ExternalScriptEditorView from "./ExternalScriptEditorView";
import { activateAccount } from "src/legacy/redux/actions/integrations/externalScript.jsx";
import {trackAdoptionMetricsForPluginConnectedEvent} from 'src/legacy/redux/actions/adoption';

const mapStateToProps = (state, ownProps) => {
  return {
    activating: state.legacyRootReducer.settings.integrations.externalScript.activation.activating,
    error: state.legacyRootReducer.settings.integrations.externalScript.activation.error
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    activateAccount: (configuration) => {
      return dispatch(activateAccount(configuration));
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName));
    }
  };
};

const ExternalScriptEditorPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExternalScriptEditorView);

export default ExternalScriptEditorPage;
